module.exports = __webpack_public_path__ + "static/SideTrayVertical-0dfbb39727622452e11bd2a3a28ec491.jpg";